import { initGapi } from './gapi';
import { fetchMe } from './users';

/** 
 * Boot action, called at app start
 * Initializes gapi and fetches current user billing from API 
 * */
export const boot = gapiConfig => dispatch =>
    dispatch(initGapi(gapiConfig))
        .then(_ => dispatch(fetchMe()));



// WEBPACK FOOTER //
// ./src/actions/index.js